
function reducer(state = [], action) {
    switch (action.type) {
        case 'WAIVER/SET':
            return action.waiver;
        case 'WAIVER/CLEAR':
            return null;
        default:
            return state;
    }
}

export default reducer;